import React from 'react';
import propTypes from 'prop-types';
export const ShoppingBagIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 489.4 489.4"
      enableBackground="new 0 0 489.4 489.4"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M349,120.8v-16.5C349,46.8,302.2,0,244.7,0S140.4,46.8,140.4,104.3v16.5H64.6v302.8c0,36.3,29.5,65.8,65.8,65.8H359
		c36.3,0,65.8-29.5,65.8-65.8V120.8H349z M166.1,197.6c-12.2,0-22.1-9.9-22.1-22.1c0-12.2,9.9-22.1,22.1-22.1
		c12.2,0,22.1,9.9,22.1,22.1C188.2,187.8,178.3,197.6,166.1,197.6z M300.9,120.8H188.5v-16.5c0-31,25.2-56.2,56.2-56.2
		s56.2,25.2,56.2,56.2V120.8z M323.3,197.6c-12.2,0-22.1-9.9-22.1-22.1c0-12.2,9.9-22.1,22.1-22.1s22.1,9.9,22.1,22.1
		C345.3,187.8,335.5,197.6,323.3,197.6z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
ShoppingBagIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
ShoppingBagIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
